import { render, staticRenderFns } from "./LeaveUpList.vue?vue&type=template&id=b3a3f670&scoped=true&"
import script from "./LeaveUpList.vue?vue&type=script&lang=js&"
export * from "./LeaveUpList.vue?vue&type=script&lang=js&"
import style0 from "./LeaveUpList.vue?vue&type=style&index=0&id=b3a3f670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3f670",
  null
  
)

export default component.exports